import { render, staticRenderFns } from "./KYCOveridePortal.vue?vue&type=template&id=7d0f9228&scoped=true&"
import script from "./KYCOveridePortal.vue?vue&type=script&lang=js&"
export * from "./KYCOveridePortal.vue?vue&type=script&lang=js&"
import style0 from "./KYCOveridePortal.vue?vue&type=style&index=0&id=7d0f9228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0f9228",
  null
  
)

export default component.exports